<template>
  <div>
    <div class="vx-row mb-12"></div>
    <div class="vx-row mb-12">
      <div
        v-bind:class="[
          detail > 0 ? detailShow + ' vertical-divider' : '',
          detailHide,
        ]"
      >
        <data-table
          :responseData="responseData"
          :propsParams="params"
          :header="header"
          @reloadDataFromChild="reloadData"
        >
          <template slot="thead">
            <!-- <th width="15%">
              <vs-checkbox color="success" v-on:click="addAllValidate()" v-model="validateAll">Release All</vs-checkbox>
            </th> -->
          </template>
          <template slot="tbody">
            <vs-tr
              :key="indextr"
              v-for="(tr, indextr) in responseData.cashBank"
              v-bind:class="[selectedData.ID == tr.ID ? 'colored' : '', '']"
            >
            <!-- <vs-td class="whitespace-no-wrap">
                <template v-if="selectedData.ID != tr.ID" >
                  <div class="mt-4 flex mr-1"> -->
                    <!-- <vx-tooltip text="Reopen Supplier Payment" class="mr-4">
                      <vs-button
                        color="danger"
                        type="line"
                        icon-pack="feather"
                        @click="promptConfirm(tr)"
                        icon="icon-corner-up-left"
                      />
                    </vx-tooltip> -->
                    <!-- <vx-tooltip text="View Supplier Payment" class="mr-4">
                      <vs-button
                        color="primary"
                        type="line"
                        icon-pack="feather"
                        @click="handleView(tr)"
                        icon="icon-eye"
                      />
                    </vx-tooltip> -->
                    <!-- <vx-tooltip text="Apply Payment">
                      <vs-button
                        color="blue"
                        type="line"
                        @click="applyPayment(tr)"
                        icon-pack="feather"
                        icon="icon-file-text"
                      />
                    </vx-tooltip> -->
                  <!-- </div>
                </template>
              </vs-td> -->
              <vs-td>
                {{ tr.PersonCode }} - {{ tr.PersonName }} 
              </vs-td>
              <vs-td>
                Code : {{tr.Code}}
                <br>
                Reference Code : {{tr.SourceTransaction}}
                <br>
                Payment Number : {{ getPayment(tr) }}
                <br>
                {{ tr.BankName }} {{ tr.AccountNumber }} ({{ tr.AccountName }})
              </vs-td>
              <vs-td>
                Deposit : {{priceFormat(tr.DepositValue)}}<br>

                Used : {{priceFormat(tr.CashBankManagementLine.reduce((total, b) => total + b.PaymentValue, 0))}} <br>
              </vs-td>
              <vs-td>
                <!-- Created Date : {{ dateFormat(tr.CreatedAt) }}
                <br> -->
                Payment Date : {{ dateFormat(tr.Date) }}
                <br>
                <!-- Posting Date : {{ dateFormat(tr.PostingDate) }} -->
              </vs-td>
            </vs-tr>
          </template>
        </data-table>
      </div>
      <vs-prompt
        title="Confirmation"
        color="primary"
        @accept="changeStatus"
        @cancel="closeDetail"
        @close="closeDetail"
        :buttons-hidden="false"
        :active.sync="confirmPrompt"
      >
        <div class="con-exemple-prompt">
          Supplier Payment
          <br />
          Are you sure to confirm <b>{{this.selectedDataChange.Code}}</b> supplier payment ?
          <br />
          <br />
          <!-- <vs-textarea v-model="notes"/> -->
        </div>
      </vs-prompt>

      <transition name="detail-fade">
        <div
          v-if="detail == 1"
          v-bind:class="[
            detail == 1 ? ' nonfixed vx-col md:w-2/3 w-full mb-base' : '',
            detailHide,
          ]"
        >
          <div>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                size="small"
                v-on:click="closeDetail"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
                >Close</vs-button
              >
            </vs-col>
            <form-apply :otherPayment="selectedData" @closeDetail="closeDetail" />
          </div>
        </div>
        <div
          v-if="detail == 2"
          v-bind:class="[
            detail == 2 ? ' nonfixed vx-col md:w-2/3 w-full mb-base' : '',
            detailHide,
          ]"
        >
          <div>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                size="small"
                v-on:click="closeDetail"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
                >Close</vs-button
              >
            </vs-col>
            <form-view :selected="selectedData" @closeDetail="closeDetail" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
// import { dataPayment } from "../../../../services/api/payment";
import formApply from "../apply-form.vue";
import form_view from "../form-view.vue";
import moment from "moment";
export default {
  props: {
    selected: Object,
    option: Object,
  },
  components: {
    "form-apply": formApply,
    "form-view":form_view,
  },
  data() {
    return {
      typePayment: ["", "Giro", "Cheque", "Transfer"],
      confirmPrompt: false,
      cancelPrompt:false,
      status:0,
      params: {
        search: "",
        length: 10,
        page: 1,
        order: "desc",
        sort: "created_at",
      },
      header: [
        // {
        //   text: "Action",
        //   sortable: false,
        // },
        {
          text: "Supplier",
          value: "customer_code",
          // width: '5%'
        },
        {
          text: "Payment",
          value: "reference_code",
        },
        {
          text: "Amount",
          sortable: false,
        },
        {
          text: "Date",
          value: "created_at",
        },
      ],
      responseData: {},
      detailShow: "vx-col md:w-1/3 w-full mb-base",
      detailHide: "core vx-col md:w-1/1 w-full mb-base",
      detail: 0,
      selectedData: {},
      selectedDataChange: {},
    };
  },
  computed: {},
  watch: {},
  mounted() {
    // this.reloadData(this.params);

    // this.getData();
    // this.page(1);
    // this.dataId = this.data[0].id
  },
  methods: {
    applyPayment(tr) {
      this.detail = 1;
      this.selectedData = tr;
    },
    getPayment(data) {
      console.log(data.CashBankManagementLine);

      let paymentCode = "";
      data.CashBankManagementLine.forEach(e => {
        paymentCode += e.PaymentCode
      });

      return paymentCode
    },
    handleView(selected) {
      this.selectedData = selected
      this.detail = 2;
    },
    dateFormat(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    closeDetail(params = false) {
      window.scrollTo(0, 0);
      this.detail = 0;
      this.selectedData = {
        ID: 0,
      };
      if (params == true) {
        this.reloadData(this.params);
      }
    },
    dataTable(params) {
      return new Promise((resolve, reject) => {
        this.$http.get('/api/v1/cash-bank/data-table',{
            params: {
                status: 3,
                type: 3,
                search: params.search,
                length: params.length,
                page: params.page,
                order: params.sort,
                sort: params.order,
                is_applied: true,
            }
        }).then((r) => {
          resolve(r)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    reloadData(params) {
      this.params = params;
      console.log(params);
      // this.$vs.loading();
      const dataTable = this.dataTable(params);
      dataTable.then((r) => {
        console.log(r);
        if (r.code == 500) {
          this.$vs.loading.close();
        } else if (r.code == 200) {
          this.$vs.loading.close();
          console.log(r.data.cashBank.length, "r.data.cashBank");
          this.data = r.data.cashBank;
          this.responseData = r.data;
          this.responseData.length = r.data.cashBank.length;
          // this.checkedAll = false;
        } else {
          this.$vs.loading.close();
        }
      });
     
    },
    promptConfirm(data) {
      this.confirmPrompt = true
      this.status = 0
      this.cancelPrompt = false
      this.selectedDataChange = data
      console.log("confirm")
    },
    changeStatus() {
      let params = {
        id: this.selectedDataChange.ID,
        status: this.status
      }
      this.$vs.loading();
      this.$http.post('/api/v1/other-payment/for-dn/change-status',params).then((result) => {
        this.$vs.loading.close();
          if (result.code == 200) {
            this.$vs.loading.close();
            this.reloadData(this.params);
            this.$vs.notify({
              title: "Success",
              text: "",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          } else {
            this.$vs.loading.close();
            this.reloadData(this.params);
            this.$vs.notify({
              title: "Error",
              text: result.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
        }).catch((e) => {
          console.log(e)
        
      })
    },

  },
};
</script>
<style scoped>
.nonfixed {
  position: inherit;
  padding-left: 20px;
}
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transform-origin-y: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-right: 1px solid #7367f0;
  /* min-height: 800px; */
  /* height: 100%; */
  -webkit-mask-position-y: fixed;
  /* padding: 5px; */
}
.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: beige;
}
.colored {
  border: 1px solid #7367f0;
  position: fixed;
  left: 4%;
  top: 40%;
  max-width: 30%;
  z-index: 999999999999;
  background: antiquewhite;
  background-color: antiquewhite;
}
</style>